var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b{fill:#c8d1ec;}.c{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 56,
    height: 56,
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-109.3-54.847A15.253,15.253,0,0,0-124.648-70,15.253,15.253,0,0,0-140-54.847c0,9.849,15.352,25,15.352,25S-109.3-45-109.3-54.847",
    transform: "translate(140 70)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12,24A12,12,0,0,1,3.515,3.515,12,12,0,1,1,20.486,20.486,11.922,11.922,0,0,1,12,24Zm0-19.43A7.43,7.43,0,1,0,19.432,12,7.439,7.439,0,0,0,12,4.572Z",
    transform: "translate(3.429 2.436)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicStation);
export default __webpack_public_path__ + "static/media/public_station.93e4f9b18fcd07a448047e309c9c48cd.svg";
export { ForwardRef as ReactComponent };